module.exports = __webpack_public_path__ + "img/ltkcyberweek-3x.93ecdb0.jpg";